/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_Time_ZeynepInputs */

const tr_landing_community_mock_time_zeynep = /** @type {(inputs: Landing_Community_Mock_Time_ZeynepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8dk`)
};

const en_landing_community_mock_time_zeynep = /** @type {(inputs: Landing_Community_Mock_Time_ZeynepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8m`)
};

const de_landing_community_mock_time_zeynep = /** @type {(inputs: Landing_Community_Mock_Time_ZeynepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 Min`)
};

const ru_landing_community_mock_time_zeynep = /** @type {(inputs: Landing_Community_Mock_Time_ZeynepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 мин`)
};

/**
* | output |
* | --- |
* | "8m" |
*
* @param {Landing_Community_Mock_Time_ZeynepInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_time_zeynep = /** @type {((inputs?: Landing_Community_Mock_Time_ZeynepInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_Time_ZeynepInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_time_zeynep(inputs)
	if (locale === "de") return de_landing_community_mock_time_zeynep(inputs)
	if (locale === "ru") return ru_landing_community_mock_time_zeynep(inputs)
	return tr_landing_community_mock_time_zeynep(inputs)
});